import React, { useRef } from "react";
import startupBahrain from "../../images/brandLogos/startupBahrainLargeWithBg.webp";
import khaleejTimesLargeWithBg from "../../images/brandLogos/khaleejTimesLargeWithBg.webp";
import abuDhabiTvInArabic from "../../images/brandLogos/abuDhabiTvInArabic.webp";
import startupGrindLargeWithBg from "../../images/brandLogos/startupGrindLargeWithBg.webp";
import gitexFutureStarsLarge from "../../images/brandLogos/gitexFutureStarsLarge.webp";
import arabianBusiness from "../../images/brandLogos/arabianBusiness.webp";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";

function StrablForYourBusinessSection() {
  const sectionRef = useRef(null);

  useGSAP(
    () => {
      gsap.fromTo(
        sectionRef.current,
        {
          opacity: 0,
          y: 100,
        },
        {
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 80%",
            end: "top 75%",
            scrub: false,
            toggleActions: "play none none reverse",
          },
          opacity: 1,
          y: 0,
          duration: 1,
          ease: "sine.out",
        }
      );
    },
    {
      scope: sectionRef.current,
    }
  );

  return (
    <section
      className="mt-24 xl:mt-52 px-6 flex flex-col items-center max-w-[634px] xl:max-w-none mx-auto"
      ref={sectionRef}
    >
      <h2 className="text-[42px] xl:text-[50px] font-HalvarBreitBold text-black text-center -tracking-[1px] ">
        Get STRABL for your business today
      </h2>
      <p className="text-xl xl:text-[30px] font-HalvarBreitMedium text-black text-center -tracking-[2%] xl:-tracking-[0.6px] ">
        Fill in the form and we'll get you started
        <br />
        <span className="text-base xl:text-xl -tracking-[2%] xl:-tracking-[0.4px]">
          *(We promise, none of the lengthy on-boading stuff)
        </span>
      </p>
      <button
        className="mt-8 text-lg font-gtAmericaMedium text-center uppercase leading-[21.69px] text-white bg-[#100C08] border border-black rounded w-fit pb-3 pt-3.5 px-6 "
        onClick={() => {
          window.open("https://forms.fillout.com/t/gM3KTnEim2us", "_blank");
        }}
      >
        GET STRABL NOW
      </button>

      <section className="mt-24 xl:mt-28 w-full xl:w-fit border-4 border-black rounded-[20px] py-[38px] xl:px-[30px] grid grid-cols-2 xl:flex items-center gap-x-2.5 gap-y-2.5 xl:gap-x-[18px]">
        {/* Featured In */}
        <div className="w-full sm:w-fit h-[66px] bg-transparent sm:bg-black py-2.5 px-5 rounded-[10px] col-span-full flex items-center justify-center mx-auto xl:mx-0 xl:mr-0.5">
          <h3 className="text-[28px] xl:text-lg font-HalvarBreitBold text-black sm:text-white text-center leading-[54px] -tracking-[2%]">
            Featured In
          </h3>
        </div>

        <section className="col-span-full flex items-center justify-center gap-2.5 mt-8 xl:mt-0">
          <div
            className="rounded-[10px] bg-[#ED2738] flex items-center justify-center w-[143px] xl:w-[160px] h-[66px] cursor-pointer"
            onClick={() => {
              window.open(
                "https://www.startupbahrain.com/features/with-borrowblob-you-try-out-your-favorite-products-before-making-a-purchase/",
                "_blank"
              );
            }}
          >
            <img
              src={startupBahrain}
              alt="Startup Bahrain"
              width={108}
              height={61}
              loading="lazy"
            />
          </div>
          <div
            className="rounded-[10px] bg-[#2DB0FE] flex items-center justify-center w-[143px] xl:w-[160px] h-[66px]  cursor-pointer"
            onClick={() => {
              window.open(
                "https://www.khaleejtimes.com/business/commitment-to-sustainable-living-provides-opportunities-for-uae-businesses",
                "_blank"
              );
            }}
          >
            <img
              src={khaleejTimesLargeWithBg}
              alt="Khaleej Times"
              width={86}
              height={62}
              loading="lazy"
            />
          </div>
          <div
            className="rounded-[10px] bg-[#5B0F8D] hidden sm:flex items-center justify-center w-[143px] xl:w-[160px] h-[66px]  cursor-pointer"
            onClick={() => {
              window.open(
                "https://adtv.ae/video/27972878/%D8%B1%D9%88%D8%A7%D8%AF-%D8%A7%D9%84%D8%A7%D8%B3%D8%AA%D8%AF%D8%A7%D9%85%D8%A9",
                "_blank"
              );
            }}
          >
            <img
              src={abuDhabiTvInArabic}
              alt="Abu Dhabi Tv"
              width={101}
              height={43}
              loading="lazy"
            />
          </div>
        </section>

        <section className="col-span-full grid grid-cols-2 sm:flex items-center justify-center gap-2.5">
          <div className="rounded-[10px] bg-[#5B0F8D] flex sm:hidden items-center justify-center w-[143px] xl:w-[160px] h-[66px] ml-auto sm:ml-0">
            <img
              src={abuDhabiTvInArabic}
              alt="Abu Dhabi Tv"
              width={101}
              height={43}
              loading="lazy"
            />
          </div>
          <div className="rounded-[10px] bg-black flex items-center justify-center w-[143px] xl:w-[160px] h-[66px]">
            <img
              src={gitexFutureStarsLarge}
              alt="Gitex Future Stars"
              width={79}
              height={79}
              loading="lazy"
            />
          </div>
          <div className="rounded-[10px] bg-[#FF2A46] flex items-center justify-center w-[143px] xl:w-[160px] h-[66px] ml-auto sm:ml-0">
            <img
              src={startupGrindLargeWithBg}
              alt="Startup Grind"
              width={108}
              height={61}
              loading="lazy"
            />
          </div>
          <div className="rounded-[10px] bg-[#EC1D27] flex items-center justify-center w-[143px] xl:w-[160px] h-[66px]">
            <img
              src={arabianBusiness}
              alt="Arabian Business"
              width={149}
              height={30}
              loading="lazy"
            />
          </div>
        </section>
      </section>
    </section>
  );
}

export default StrablForYourBusinessSection;
